import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataType, OutputSnapshotVersionKey } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { OutputSnapshotVersionSchema } from '../schema/InputDataSchema';

const getDescriptionOutputSnapshotVersion = (
  params?: OutputSnapshotVersionKey,
) =>
  apiClient
    .get<InputDataType>(expand(InputDataUrl.OUTPUT_SNAPSHOT_VERSION, params))
    .then((response) => OutputSnapshotVersionSchema.parse(response.data));

export const useDescriptionOutputSnapshotVersionQuery = createApiQueryHook(
  ['useDescriptionOutputSnapshotVersion'],
  getDescriptionOutputSnapshotVersion,
);
